<template>
  <div v-if="teamsiteConfig" class="divider" :style="{height: `${size}px`, backgroundColor: teamsiteConfig.color}">&nbsp;</div>
</template>

<script>

export default {
  name: 'divider',

  props: {
    size: {
      type: Number,
      default: 5
    }
  },
}
</script>

<style lang="scss" scoped>
.divider {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Divider.vue